<script setup lang="ts">
import Autocomplete from '@/components/forms/Autocomplete/Autocomplete.vue';
import SearchField from '@/components/filter/SearchField.vue';
import { getTranslatedOptions } from '@/utils/helper';
import { MedicalSystemOverviewFilterObject } from '../types';
import { computed } from 'vue';
import PtwResetFilterButton from '@/components/buttons/PtwResetFilterButton.vue';
import { MedicalSystemRtSystemDto } from '@/api/generator';
import { uniq } from 'lodash';

const modelValue = defineModel<MedicalSystemOverviewFilterObject>({
  required: true,
});

interface MedicalSystemOverviewFilterProps {
  items: MedicalSystemRtSystemDto[];
}

const props = defineProps<MedicalSystemOverviewFilterProps>();

const subCategoryOptions = computed(() =>
  getTranslatedOptions(
    uniq(props.items.map((medSys) => medSys.subCategory)) ?? [],
    'MedicalSystemSubCategoryEnum',
  ),
);

const categoryOptions = computed(() =>
  getTranslatedOptions(
    uniq(props.items.map((medSys) => medSys.category)) ?? [],
    'RtSystemCategoryEnum',
  ),
);

function clearFilters() {
  modelValue.value = {};
}
</script>

<template>
  <v-row class="align-center mt-2 pl-2 pr-2">
    <v-col cols="12" sm="6" md="3" lg="3" class="pa-2">
      <SearchField v-model="modelValue.search" :placeholder="$t('Search')" />
    </v-col>
    <v-col cols="12" sm="6" md="3" lg="3" class="pa-2">
      <Autocomplete
        v-model="modelValue.category"
        :label="$t('Category_one')"
        :items="categoryOptions"
        :placeholder="$t('Category_one')"
        multiple
        chips
        emptyAsUndefined
      ></Autocomplete>
    </v-col>
    <v-col cols="12" sm="6" md="3" lg="3" class="pa-2">
      <Autocomplete
        v-model="modelValue.subCategory"
        :label="$t('Type_one')"
        :items="subCategoryOptions"
        :placeholder="$t('Type_one')"
        multiple
        chips
        emptyAsUndefined
      ></Autocomplete>
    </v-col>
    <v-col md="3" lg="1" class="d-flex align-center justify-start pa-2">
      <PtwResetFilterButton @click="clearFilters" />
    </v-col>
  </v-row>
</template>
